import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, TextInput, Textarea, Button, Stack, Text } from '@mantine/core';
import { PaperPlaneTilt } from '@phosphor-icons/react';
import { useAuth } from '../hooks/useAuth';
import { useNotifications } from '../hooks/useNotifications';
import api from '../utils/api';

// Formularz kontaktu/wsparcia z poziomu panelu. Email podpowiadany z konta
// zalogowanego użytkownika, ale edytowalny.
export default function SupportModal({ opened, onClose }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { addNotification } = useNotifications();
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (opened) {
      setEmail(user?.email || '');
      setSubject('');
      setMessage('');
    }
  }, [opened, user]);

  const send = async () => {
    if (!message.trim()) return;
    setSending(true);
    try {
      await api.post('/accounts/app-contact/', { email, subject, message });
      addNotification(t('support.sent'), 'success');
      onClose();
    } catch (err) {
      addNotification(err.response?.data?.error || t('support.error'), 'error');
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title={t('support.title')} size="md" radius="md">
      <Stack gap="sm">
        <Text size="sm" c="dimmed">{t('support.subtitle')}</Text>
        <TextInput
          label={t('support.emailLabel')}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.currentTarget.value)}
        />
        <TextInput
          label={t('support.subjectLabel')}
          placeholder={t('support.subjectPlaceholder')}
          value={subject}
          onChange={(e) => setSubject(e.currentTarget.value)}
        />
        <Textarea
          label={t('support.messageLabel')}
          placeholder={t('support.messagePlaceholder')}
          value={message}
          onChange={(e) => setMessage(e.currentTarget.value)}
          minRows={5}
          autosize
          required
        />
        <Button
          leftSection={<PaperPlaneTilt size={16} />}
          onClick={send}
          loading={sending}
          disabled={!message.trim()}
          color="brand"
          mt={4}
        >
          {t('support.send')}
        </Button>
      </Stack>
    </Modal>
  );
}
